import { makeAutoObservable, toJS } from 'mobx';
import { configure } from 'mobx';
import { api } from '../api';
import { storage } from '../helpers/storage.js';
import { cell_t, project_t, task_t } from '../logic/types';
import M from 'materialize-css';
import { projectsData, projectsStore } from './projectsStore';
import { isCellValid, isProjectValid } from '../helpers/validators';
const { v4: uuidv4 } = require('uuid');

configure({ enforceActions: 'never' });

interface project_details_data_t {
    state: 'init' | 'loading' | 'error' | 'success';
    project: project_t | null;
    projectStatus?: 'existing' | 'new';
    projectBeforeChanges: null | project_t;
    projectIdx: null | number;
    project_id: string;
    cellId: string | null;
    copyNum: number;
    isDataSaved?: boolean;
}
class ProjectDetails {
    constructor() {
        makeAutoObservable(this);
    }

    data: project_details_data_t = {
        state: 'init',
        project: null,
        projectStatus: 'new',
        projectBeforeChanges: null,
        cellId: null,
        projectIdx: null,
        project_id: '',
        copyNum: 1,
        isDataSaved: true,
    };

    saveProject = async () => {
        this.data.state = 'loading';

        let project = {
            name: this.data.project?.name,
            id: this.data.project?.id,
            type: this.data.project?.type,
            creationDate: this.data.project?.creationDate,
        };
        try {
            const response = await api.saveProject(project);
            projectsStore.fetchProjects();

            // if (!project.id) {
            //     project.id = response.data;
            // }
            // this.data.project = project;
            // this.data.projectBeforeChanges = project;
            this.data.state = 'success';
            M.toast({ html: 'Project successfully saved!', classes: 'teal lighten-2' });
        } catch (err) {
            this.data.state = 'error';
            M.toast({ html: 'An error happened. Could not save the project.', classes: 'red' });
        }
    };
    saveCell = async (cell_id: string) => {
        projectsStore.fetchProjects();
        if (!this.data.project_id) return;
        this.data.state = 'loading';
        this.data.cellId = cell_id;
        let project = JSON.parse(JSON.stringify(this.data.project));
        try {
            let cell = this.getCurrentCell();
            if (!cell) return;

            const newCellWithFilteredURLChecks = {
                ...cell,
                tasks: cell.tasks.map((t) => ({
                    ...t,
                    urlCheck: t.urlCheck.filter((url) => url.length > 0),
                })),
            };
            console.log(
                '🚀 [NM]  ~ file: projectDetailsStore.ts ~ line 77 ~ ProjectDetails ~ saveCell= ~ newCellWithFilteredURLChecks',
                newCellWithFilteredURLChecks
            );

            const response = await api.saveCell(this.data.project_id, newCellWithFilteredURLChecks);
            // if (!project.id) {
            //     project.id = response.data;
            // }
            // this.data.project = project;
            // this.data.projectBeforeChanges = project;
            this.data.state = 'success';
            M.toast({ html: 'Cell is successfully saved!', classes: 'teal lighten-2' });
        } catch (err) {
            this.data.state = 'error';
            M.toast({ html: 'An error happened. Could not save the project.', classes: 'red' });
        }
    };

    onSaveProject = (page: 'cell' | 'project') => {
        if (page === 'project') {
            if (isProjectValid(JSON.parse(JSON.stringify(this.data.project)))) {
                this.saveProject();
                if (!this.data.cellId) return;
                if (this.data.project) {
                    this.getProject(this.data.project?.id);
                }
                this.saveCell(this.data.cellId);
            } else {
                this.data.state = 'error';
                M.toast({ html: 'Please insert all required data for this project.', classes: 'red' });
            }
        } else {
            if (isCellValid(this.getCurrentCell())) {
                if (!this.data.cellId) return;
                this.saveCell(this.data.cellId);
                if (this.data.project) {
                    this.getProject(this.data.project?.id);
                }
            } else {
                this.data.state = 'error';
                M.toast({ html: 'Please insert all required data for this cell. URL check must be part of URL.', classes: 'red' });
            }
        }
    };

    getCurrentCell = (): cell_t | undefined => {
        if (!this.data.project) return;
        let cell = this.data.project.cells.find((el: cell_t) => el.id === this.data.cellId);
        return cell;
    };
    getCurrentTaskIdx = (id: number) => {
        if (!this.data.project) return;
        let cell = this.getCurrentCell();
        if (cell === undefined) return;
        let idx = cell.tasks.findIndex((el: task_t) => el.id == id);
        return idx;
    };

    onUpdateCells = (cells: cell_t[]) => {
        // if (!this.data.project_id) return;
        let project = JSON.parse(JSON.stringify(this.data.project));
        project.cells = cells;
        this.data.project = project;
    };
    duplicateTask = async (id: number) => {
        let project: project_t = JSON.parse(JSON.stringify(projectDetailsData.project));
        // let project:  = projects.find((proj: project_t) => proj.id === id);
        if (this.data.cellId === null) return;
        let cell = project.cells.find((cell) => cell.id === this.data.cellId);
        if (!cell) return;
        project.cells = [...project.cells, cell];
        if (!cell) return;
        let task: any = { ...cell.tasks.find((task: task_t) => task.id == id) };
        if (!task) return;
        if (task.name.includes('copy')) {
            let name = task.name.split('-');
            if (/[0-9]/g.test(name[1])) {
                task.name = `${name[0]}-${name[1].replace(/[0-9]/g, this.data.copyNum)}`;
            } else {
                task.name = `${task.name}-(${this.data.copyNum})`;
            }
        } else {
            task.name += '-copy';
            this.data.copyNum = 0;
        }
        task.id = Math.floor(Math.random() * 10);
        cell.tasks.unshift(task);
        this.data.project = project;
        let user = storage.getItem('user');
        if (!user) return;
        try {
            // this.saveProject()
        } catch (err) {
            M.toast({ html: 'An error happened. Could not duplicate the project.', classes: 'red' });
        }
        this.data.copyNum = this.data.copyNum + 1;
    };

    getProject = (id: any) => {
        this.data.state = 'loading';
        this.data.project_id = id;
        projectsStore
            .fetchProjects()
            .then((response) => {
                this.data.state = 'success';
                let project = projectsData.projects.find((project) => project.id === id);

                let index = projectsData.projects.findIndex((project) => project.id === id);
                this.data.projectIdx = index;
                if (!project) window.location.href = '/projects';
                else {
                    // project.cells = JSON.parse(project.cells);
                    // if (project.cells && project.cells.length) {
                    //     project.cells.forEach((cell) => {
                    //         cell.tasks.forEach((task) => {
                    //             if (typeof task.urlCheck === 'string') {
                    //                 task.urlCheck = [task.urlCheck];
                    //             }
                    //         });
                    //     });
                    // } else {
                    if (project.id) {
                        this.getCells(project.id);
                    }
                    project.cells = [];
                    // }

                    if (typeof project.cells === 'string') project.cells = JSON.parse(project.cells);
                    this.data.project = project;
                    this.data.projectBeforeChanges = project;
                }
            })
            .catch((err) => {
                this.data.state = 'error';

                M.toast({ html: 'An error happened. Could not load the project.', classes: 'red' });
            });
    };
    getCells = async (project_id: string) => {
        let {
            data: {
                cells: { Items },
            },
        } = await api.fetchProjectsCells(project_id);
        if (this.data.project) this.data.project.cells = Items;
    };

    deleteCell = async (cell_id: string) => {
        if (!this.data.project) return;
        let project_id = this.data.project.id;
        if (!project_id) return;
        try {
            await api.deleteCell(project_id, cell_id);
            this.getProject(project_id);
            M.toast({ html: 'Success! you successfully deleted cell', classes: 'teal lighten-2' });
        } catch (error) {
            console.log(error);
            M.toast({ html: 'An error happened. Could not delete cell.', classes: 'red' });
        }
    };

    duplicateCell = async (cellId: string) => {
        this.data.state = 'loading';
        const project = toJS(this.data.project);
        const foundCell = project?.cells.find((cell) => cell.id === cellId);
        const cellToDuplicate: cell_t | undefined = JSON.parse(JSON.stringify(foundCell));

        if (!foundCell || !cellToDuplicate?.id) return;

        let newId = uuidv4();
        cellToDuplicate.id = newId;
        cellToDuplicate.SK = cellToDuplicate.SK?.replace(`CELL#${foundCell?.id}`, `CELL#${cellToDuplicate.id}`);

        if (cellToDuplicate.name.includes('copy')) {
            let name = cellToDuplicate.name.split('-');
            if (/[0-9]/g.test(name[1])) {
                cellToDuplicate.name = `${name[0]}-${name[1].replace(/[0-9]/g, String(this.data.copyNum))}`;
            } else {
                cellToDuplicate.name = `${cellToDuplicate.name}-(${this.data.copyNum})`;
            }
        } else {
            cellToDuplicate.name += '-copy';
            this.data.copyNum = 0;
        }

        this.data.copyNum = this.data.copyNum + 1;

        project?.cells.push({
            ...cellToDuplicate,
        });

        try {
            await api.saveProject(project);
            await api.saveCell(project?.id + '', cellToDuplicate);
            this.data.project = project;
            this.data.state = 'success';
        } catch (err) {
            M.toast({ html: 'An error happened. Could not duplicate the cell.', classes: 'red' });
            this.data.state = 'error';
        }
    };
}

export let projectDetailsStore = new ProjectDetails();
export let projectDetailsData = projectDetailsStore.data;
